import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	width: 100%;
	height: 100%;
	overflow: hidden;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
	margin: auto;
	width: 680px;
	overflow: hidden;
	background-color: #fff;
	padding: 40px;
	border-radius: 8px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

	button {
		margin-top: 20px;
	}

	svg {
		width: 200px;
		height: 200px;
	}

	h2 {
		color: ${tokens.color_primary};
		margin-bottom: 2rem;
	}

	p {
		color: ${tokens.color_gray_dark};
		margin-bottom: 10px;
	}
`;
